import React from 'react';
import { Box, Spinner } from '@zillow/constellation-10';

const SpinnerContainer: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<unknown>>> = () => {
  return (
    <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '1', height: '100vh' }}>
      <Spinner size="lg" />
    </Box>
  );
};

export default SpinnerContainer;
